import React, { useState, useEffect, useContext, useRef } from "react";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";

import { SnackContext } from "context/SnackProvider";
import instance, { GetUserRole, getErrorMessage } from "api/definitions";
import InfoTooltip from "components/atoms/info/InfoTooltip";
import LocationPermissionTable from "components/molecules/table/LocationPermissionTable";

const AddPermission = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const snackContext = useContext(SnackContext);

  useEffect(() => {
    if (props.load) {
      setIsLoaded(false);

      const fullURL = `local/${props.idLocation}/permissao`;

      const request = {
        identificador: props.name,
        grupo: props.type,
      };

      instance
        .post(fullURL, request)
        .then(function (response) {
          setIsLoaded(true);
          const result = response.data;
          if (!result.performed) {
            snackContext.setMessage("Erro", "error");
          } else {
            snackContext.setMessage(`Permissão salva com sucesso`, "success");
            props.handleClose();
          }
        })
        .catch(function (error) {
          setIsLoaded(true);
          const msg = getErrorMessage(error);
          snackContext.setMessage(msg, "error");
        });
    }
  }, [props, snackContext]);

  if (props.load && !isLoaded) return <CircularProgress />;
};

const LocationPermission = (props) => {
  const [load, setLoad] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [reloadTable, setReloadTable] = useState(false);

  const [type, setType] = useState(0);
  const [name, setName] = useState("");

  const [errorName, setErrorName] = useState(false);

  const refName = useRef(null);

  const userRole = GetUserRole();

  const handleShowForm = () => {
    !showForm && setShowForm(true);
  };

  const handleNotShowForm = () => {
    showForm && setShowForm(false);
  };

  const handleClose = (event) => {
    load && setLoad(false);
    handleNotShowForm();
    setReloadTable(!reloadTable);
    setName("");
    errorName && setErrorName(false);
  };

  const handleChangeName = (event) => {
    setName(event.target.value);
  };

  const handleChangeType = (event) => {
    const newValue = event.target.value;
    setType(newValue);
  };

  const handleClick = () => {
    if (!name) {
      refName.current.focus();
      if (!errorName) setErrorName(true);
      alert("Por favor, preencha o campo identificador.");
    } else {
      setLoad(true);
    }
  };

  const NewButtons = () => {
    const handleNew = () => {
      handleClose();
      handleShowForm();
    };

    return (
      <Box>
        {!showForm && (
          <Button variant="contained" onClick={handleNew}>
            Adicionar Permissão de Reservar este Local
          </Button>
        )}
      </Box>
    );
  };

  return (
    <>
      {userRole > 5 && <NewButtons />}
      {userRole > 5 && showForm && (
        <Box id="formLocationPermission">
          <Box id="ControlButtons">
            <InfoTooltip placement="top-start" title="Voltar">
              <IconButton onClick={handleNotShowForm}>
                <ArrowBackIcon />
              </IconButton>
            </InfoTooltip>
            <InfoTooltip placement="top-start" title="Salvar">
              <IconButton onClick={handleClick}>
                <SaveIcon />
              </IconButton>
            </InfoTooltip>
          </Box>
          <Box>
            <Box>
              <FormControl id="formType" sx={{ ml: 1 }}>
                <FormLabel id="radio-type-group-label">
                  Adicionar Permissão de Reservar este Local para um individuo
                  ou grupo do LDAP
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="radio-type-group"
                  name="controlled-radio-type-group"
                  value={type}
                  onChange={handleChangeType}
                >
                  <FormControlLabel value={0} control={<Radio />} label="CPF" />
                  <FormControlLabel
                    value={1}
                    control={<Radio />}
                    label="Grupo"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>
          <Box>
            <TextField
              fullWidth
              margin="dense"
              value={name}
              onChange={handleChangeName}
              id="name"
              label="Nome"
              name="name"
              autoComplete="off"
            />
          </Box>
        </Box>
      )}

      <Box id="boxData" sx={{ mt: 2 }}>
        <LocationPermissionTable
          idLocation={props.idLocation}
          reloadTable={reloadTable}
        />
        <AddPermission
          idLocation={props.idLocation}
          name={name}
          type={type}
          load={load}
          handleClose={handleClose}
        />
      </Box>
    </>
  );
};

export default LocationPermission;
